import React from 'react';
import { useDateService } from 'framework/utils';
import { TextField } from 'framework/ui/field';
import { Box } from '@mui/material';

const LeaveDurationLayout = ({ days, startDate, endDate }: { days: number; startDate: string; endDate: string }) => {
  const { getDaysBetween } = useDateService();
  const requestDuration = getDaysBetween(endDate, startDate) + 1;
  const isHolidaysExcluded = requestDuration > days;
  let selectedTimeUnit = null;
  if (days === 1) {
    selectedTimeUnit = 'day';
  } else if (days > 1 || days === 0) {
    selectedTimeUnit = 'days';
  }
  const message = isHolidaysExcluded ? `${selectedTimeUnit}, holidays excluded` : `calendar ${selectedTimeUnit}`;

  const value = selectedTimeUnit ? `(${days} ${message})` : null;

  return (
    <Box sx={{ marginBottom: '11px', '@media (min-width: 1440px)': { marginTop: '22px' } }}>
      {value && <TextField value={value} />}
    </Box>
  );
};

export default LeaveDurationLayout;
